import { render } from "./ParentAdd.vue?vue&type=template&id=11c3a757&scoped=true&ts=true"
import script from "./ParentAdd.vue?vue&type=script&lang=ts"
export * from "./ParentAdd.vue?vue&type=script&lang=ts"

import "./ParentAdd.vue?vue&type=style&index=0&id=11c3a757&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c3a757"]])

export default __exports__